/* THE ORDER STATUS UPLOAD BUTTON (Max 02/11: "báo cáo này thiếu nút upload" — the button that was only on Frames by Model &
   Colour, out on Overseas Sales too). The same file feeds both: the frame counts, and the product attributes of the SAP
   billing lines on the Overseas Sales dashboard. The office machine pushes the newest file every morning at 08:00; this
   button is for a file wanted sooner. Drawn only for people with sales_model_color at edit, as the route requires. */
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Upload } from 'lucide-react';
import { BACKEND_URL } from './backendConfig';

const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const dmy = (s) => (s ? `${s.slice(8, 10)}/${MON[Number(s.slice(5, 7)) - 1]}/${s.slice(0, 4)}` : '');

export default function OrderStatusUpload({ onDone, onMessage }) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const fileRef = useRef(null);
  const say = (m) => onMessage && onMessage(m);
  const onPick = async (e) => {
    const f = e.target.files && e.target.files[0];
    e.target.value = '';
    if (!f) return;
    setBusy(true);
    say({ busy: t('xOrderStatus.readingLong') });
    try {
      const r = await fetch(`${BACKEND_URL}/api/model-color/upload?name=${encodeURIComponent(f.name)}`, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/octet-stream' }, body: f });
      const d = await r.json().catch(() => ({ error: `HTTP ${r.status}` }));
      if (!r.ok) throw new Error(d.error || 'Error');
      say({ ok: t('xOrderStatus.uploaded', { n: d.upload.row_count.toLocaleString('en-US'), from: dmy(d.upload.sd_min), to: dmy(d.upload.sd_max) }) });
      if (onDone) onDone(d.upload);
    } catch (e2) { say({ err: e2.message }); } finally { setBusy(false); }
  };
  return (
    <>
      <button type="button" className="pa-btn primary" disabled={busy} onClick={() => fileRef.current && fileRef.current.click()} data-os-upload>
        <Upload size={14} /> {busy ? t('xOrderStatus.reading') : t('xOrderStatus.upload')}
      </button>
      <input ref={fileRef} type="file" accept=".xlsx,.xlsm" hidden onChange={onPick} />
    </>
  );
}
